import { Config } from '@telstra-connect/config/config';
import { isEDN } from '@telstra-connect/config/auth-config';

export const hostUrl = Config.apiHostUrl;
export const ogwHostUrl = Config.apiOGWHostUrl;
// include the credentials only if
export const includeCredentials = isEDN;

export enum HttpCodes {
    BadRequest = 400,
    Unauthorized = 401,
    NotFound = 404,
    ServiceUnavailable = 503,
    RequestTimeout = 504,
    Success = 200,
    Created = 201,
    NoContent = 204,
    InternalServerError = 500,
    UnprocessableEntity = 422
};

export const httpCodeMessages = [{
    key: HttpCodes.BadRequest, value: 'Error executing request, try again'
}, {
    key: HttpCodes.Unauthorized, value: 'Unauthorized'
}, {
    key: HttpCodes.NotFound, value: 'Not Found'
}, {
    key: HttpCodes.ServiceUnavailable, value: 'Service Unavailable'
}, {
    key: HttpCodes.RequestTimeout, value: 'Request timeout, try again later'
}, {
    key: HttpCodes.Success, value: 'Success'
}, {
    key: HttpCodes.Created, value: 'Created'
}, {
    key: HttpCodes.NoContent, value: 'No Content Found'
}, {
    key: HttpCodes.InternalServerError, value: 'Internal Server Error'
}, {
    key: HttpCodes.UnprocessableEntity, value: 'Unprocessable Entity'
}
];

export type RequestMethods = 'GET' | 'POST' | 'PUT' | 'PATCH' | 'DELETE';

export enum ContentTypes {
    JSON = 'application/json',
    Form = 'application/x-www-form-urlencoded',
    PDF = 'application/pdf',
    CSV = 'text/csv',
    ZIP = 'application/zip',
    OCTET_STREAM = 'application/octet-stream'
};

export enum HttpHeaders {
    ContentType = 'Content-Type',
    ContentDisposition = 'Content-Disposition'
};

export const RequestModeCors: RequestMode = 'cors';

export const PlrTransactionIdType = {
    0: 'DASHBOARD_SELECT_CIDN_PAGE',
    1: 'SUPPORT_FEEDBACK_PAGE',
    2: 'FIRST_TIME_SELECT_CIDN_PAGE',
    3: 'VIEW_REQUEST_LIST_PAGE',
    4: 'VIEW_REQUEST_CATALOGUE_PAGES',
    5: 'VIEW_REQUEST_FORM_PAGES',
}

export const PLRPathList = [
    '/app/dashboard',
    '/app/support/feedback',
    '/app/select-company',
    '/app/service-requests/open',
    '/app/service-requests/closed',
    '/app/service-requests/new-request'
]

export const LABELS = {
    API_ERROR: {
        LOST_CONNECTION: {
            TITLE: "Data not available right now",
            MESSAGE: "Refresh the page or report an error if there's still a problem.",
            REPORT_ERROR: 'Report an error',
            REFRESH_THE_PAGE: 'Refresh',
        },
    },
    NO_DATA_ERROR: {
        TITLE: "No support enquiries",
        MESSAGE_MULTI_CIDN: "The company you selected has no support enquiries.",
        MESSAGE: "There are no support enquiries to manage.",
        SUBMIT_ENQUIRY: 'Submit a support enquiry'
    },
    TRY_AGAIN: 'Try again',
    REPORT_ERROR: 'Report an error',
    FILTER_DATA: {
        TITLE: 'No results found ',
        MESSAGE: 'You might need to:',
        UL_0: 'Change your company selection',
        UL_3: 'Check your filters.',
        UL_1: 'Check your search terms',
        UL_2: 'Avoid using special characters',
    },
}
